import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ScreenRotationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"screen_rotation"}/>
}
